import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ORG } from "@/lib/constants";

export function Navbar() {
  const { pathname } = useLocation();
  const links = [
    { to: "/", label: "Home" },
    { to: "/wall", label: "Live Wall" },
    { to: "/retrieve", label: "Retrieve Certificate" },
  ];
  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/75 backdrop-saturate-150 border-b border-slate-200"
    >
      <div className="tricolor-bar h-1 w-full" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <img src={ORG.logo} alt={`${ORG.name} logo`} className="w-9 h-9 shrink-0" />
          <span className="leading-none">
            <span className="block font-display font-extrabold text-lg tracking-tight text-slate-900">
              Healthy India<span className="text-[#FF9933]">.</span>
            </span>
            <span className="block text-[10px] uppercase tracking-wider text-slate-500 font-semibold mt-0.5">
              by {ORG.name}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                pathname === l.to
                  ? "text-[#0056D2] bg-blue-50"
                  : "text-slate-600 hover:text-[#0056D2] hover:bg-slate-100"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/pledge" data-testid="navbar-pledge-cta">
          <Button className="rounded-full bg-[#0056D2] hover:bg-blue-700 text-white font-semibold px-5">
            Take the Pledge
          </Button>
        </Link>
      </div>
    </header>
  );
}
